export default {"src":"/_next/static/media/ArcTopLeftRed.37c8aca2.svg","height":8,"width":7,"blurWidth":0,"blurHeight":0};